import React from 'react';

const RouterIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' className='mb-24' width='121' height='120' viewBox='0 0 121 120' fill='none'>
    <g id='icon/120'>
      <rect id='Rectangle' x='32.2296' y='55' width='55' height='17' rx='6' stroke='black' strokeWidth='4.4' strokeLinejoin='round' />
      <path
        id='Path'
        d='M42.7296 67C40.7966 67 39.2296 65.433 39.2296 63.5C39.2296 61.567 40.7966 60 42.7296 60C44.6626 60 46.2296 61.567 46.2296 63.5C46.2296 65.433 44.6626 67 42.7296 67Z'
        fill='black'
      />
      <path
        id='Vector 2115'
        d='M83.5624 94.5175C87.3184 94.1529 93.0218 91.6514 98.7949 87.1919C104.808 82.5471 109.503 75.7904 109.912 73.0003'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='3.4'
        strokeLinecap='round'
      />
      <path
        id='Vector 2116'
        d='M102.931 75.0426L110.901 69.8688L114.199 78.7802'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='3.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector 2117'
        d='M35.9717 32.7814C32.2158 33.1459 26.5124 35.6474 20.7393 40.1069C14.7262 44.7517 10.0312 51.5084 9.62206 54.2986'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='3.4'
        strokeLinecap='round'
      />
      <path
        id='Vector 2118'
        d='M16.6046 52.2796L8.63445 57.4535L5.33634 48.542'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='3.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g id='wifi'>
        <path
          id='Path_2'
          d='M77.3967 48.7192C76.4496 48.7192 75.6819 47.9514 75.6819 47.0043C75.6819 46.0572 76.4496 45.2894 77.3967 45.2894C78.3438 45.2894 79.1116 46.0572 79.1116 47.0043C79.1116 47.9514 78.3438 48.7192 77.3967 48.7192Z'
          fill='black'
        />
        <path
          id='Path_3'
          d='M77.3963 40.1032C79.7766 40.0947 82.0632 41.0149 83.7529 42.6628C83.9141 42.8191 84.018 43.0161 84.0582 43.2251C84.0982 43.4332 84.0751 43.6529 83.9835 43.8553C83.8911 44.0596 83.7387 44.2248 83.5531 44.336C83.3654 44.4484 83.1438 44.5057 82.9059 44.4924C82.6152 44.4884 82.3375 44.3722 82.1326 44.1668C80.8773 42.9307 79.1732 42.2354 77.3956 42.2354C75.618 42.2354 73.9138 42.9307 72.6592 44.1662C72.4441 44.3763 72.1626 44.4807 71.8815 44.4807C71.6003 44.4807 71.3189 44.3763 71.1046 44.167C70.8938 43.9588 70.7878 43.6867 70.7878 43.4142C70.7878 43.1418 70.8938 42.8697 71.1036 42.6624C72.7773 41.0301 75.0379 40.1112 77.3963 40.1032Z'
          fill='black'
        />
        <path
          id='Path_4'
          d='M77.3951 35C81.1313 35.0098 84.7132 36.4653 87.3638 39.0521C87.5696 39.2526 87.6861 39.5253 87.6861 39.8103C87.6861 40.0952 87.5696 40.3679 87.3638 40.5684C87.1556 40.7713 86.8735 40.8837 86.5782 40.8821C86.2852 40.8837 86.0032 40.7713 85.7955 40.5689C83.4751 38.2925 80.4355 37.1537 77.3957 37.1537C74.3558 37.1537 71.3162 38.2925 68.9958 40.569C68.7793 40.7816 68.4955 40.8873 68.2119 40.8873C67.9284 40.8873 67.6446 40.7816 67.4281 40.569C67.2148 40.3595 67.1075 40.0851 67.1075 39.8103C67.1075 39.5355 67.2148 39.2611 67.4277 39.052C70.0781 36.4653 73.66 35.0098 77.3951 35Z'
          fill='black'
        />
      </g>
    </g>
  </svg>
);

export default RouterIcon;
